const redirectToLoginIfUnauthorized = (response: Response) => {
  if (response.status === 401) {
    const currentPath = window.location.pathname;
    window.location.replace(`/login?origin=${currentPath}`);
  }
};

export default redirectToLoginIfUnauthorized;
